var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"addBtn",attrs:{"to":"/new-note"}},[_c('p',{staticClass:"h1 mt-1"},[_c('b-icon',{attrs:{"icon":"plus"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }